module.exports = __webpack_public_path__ + "static/media/bookmarked-ico.4f99fb37.svg";